<script setup>
import { ref } from 'vue';
import { __ } from 'JIX/gettext';
import { useStore } from 'vuex';
import JobadDistribution from './analysis/JobadDistribution.vue';
import HistoryCharts from './analysis/HistoryCharts.vue';
import DsBreadcrumb from 'JIX/components/ds/DsBreadcrumb.vue';


const store = useStore();

const breadCrumbItems = [
    [__('Søgeresultat'), showListMode],
    [__('Statistik')],
];

const view = ref(store.state.analysisViewMode ?? 'piechart');
const initialActiveTab = ref(store.state.analysisInitialTab ?? 'company');

function handleDataRepresentationChange(newView) {
    view.value = newView;
}

async function showListMode(){
    window.scrollTo({ top: 0, behavior: 'smooth' });
    return store.dispatch('performSearch', { newViewMode: 'list' });
}

</script>

<template>
    <section class="container mb-5">
        <DsBreadcrumb class="mb-4 ml-lg-5" :items="breadCrumbItems" />
        <div class="col-12 col-md-10 col-lg-8 mx-auto">
            <h1>{{ __('Analyse af jobsøgning') }}</h1>
            <JobadDistribution
                :data-view="view"
                :initial-active-tab="initialActiveTab"
                @data-representation-change="handleDataRepresentationChange"
            />
            <HistoryCharts />
            <button
                type="button"
                class="btn btn-secondary btn-sm mt-4"
                @click.prevent="showListMode"
            >
                {{ __('Tilbage til jobannoncer') }}
            </button>
        </div>
    </section>
</template>
